import styled, { css } from 'styled-components'

import { Cover, Reset } from '@/lib/mixins'

export const TicketsWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const TicketsView = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`

export const TicketsOuter = styled.div`
  flex: 1 1 auto;
  display: flex;
  position: relative;
  min-height: 0;
`

export const TicketsHeader = styled.header<{ align?: 'bottom' | 'center'; high?: boolean }>`
  position: relative;
  padding: ${props => props.theme.spacing.sm} ${props => props.theme.outerMargin};
  background-color: ${props => props.theme.color.primaryDark};
  color: ${props => props.theme.color.inverted};
  display: flex;
  align-items: ${props => (props.align === 'center' && !props.theme.accessibilityMode ? 'center' : 'flex-end')};
  min-height: ${props => (props.high ? '40%' : '25%')};
  flex-shrink: 0;

  ${props =>
    props.theme.contrastMode &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.color.line};
    `};

  ${props =>
    props.theme.accessibilityMode &&
    css`
      height: 69%;
    `};
`

export const TicketsHeaderContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
`

export const TicketsLogo = styled.div`
  position: relative;
  z-index: 2;
  margin-right: ${props => props.theme.outerMargin};
  svg {
    fill: currentColor;
    height: 9rem;
    width: auto;
  }
`

export const TicketsMedia = styled.div`
  ${Cover()}

  ${props =>
    props.theme.contrastMode &&
    css`
      opacity: 0.2;
    `};

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0));
  }
`

export const TicketsTitle = styled.div`
  position: relative;
  z-index: 2;
  flex: 1 1 auto;
  padding-top: 0.25rem;

  h3 {
    font-size: 1.5rem;
    color: ${props => props.theme.color.inverted};
    margin-bottom: 0;

    &:not(:last-child) {
      margin-bottom: 0.25rem;
    }
  }

  h1 {
    font-size: 4rem;
    margin-bottom: 0;
    color: ${props => props.theme.color.inverted};
    &:not(:last-child) {
      margin-bottom: 0.75rem;
    }
  }
`

export const TicketsBody = styled.div`
  flex: 1 1 auto;
  padding: ${props => props.theme.spacing.sm} ${props => props.theme.outerMargin};
  overflow: auto;

  ${props =>
    props.theme.accessibilityMode &&
    css`
      padding: 2rem;
    `};
`

export const TicketsFooter = styled.footer`
  flex-shrink: 0;
`

/* Categories */

export const TicketsCategories = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
`

export const TicketsCategoryCard = styled.button`
  ${Reset('button')};
  background-color: ${props => props.theme.color.light};
  min-height: 16rem;
  text-align: left;
  display: flex;
  flex-direction: column;
  cursor: pointer;

  h3 {
    margin-bottom: 0.5rem;
    font-size: 1.75rem;
  }

  p {
    margin-bottom: 1.5rem;
    color: ${props => props.theme.color.muted};
  }

  &:hover {
    opacity: 0.92;
  }
`

export const TicketsCategoryCardImage = styled.div`
  width: 100%;
  display: flex;
  aspect-ratio: 16 / 9;
  overflow: hidden;

  ${props =>
    props.theme.accessibilityMode &&
    css`
      aspect-ratio: 16 / 6;
    `};

  img {
    display: block;
    width: 100%;
    object-fit: cover;
  }
`

export const TicketsCategoryCardContent = styled.div`
  padding: 2rem;
  text-align: center;
`

export const TicketsEmptyMsg = styled.p`
  text-align: center;
  width: 100%;
  font-size: 1.25rem;
`
